/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/6/17
 * Copyright All Rights Reserved
 */
import React from 'react';
import PropTypes from 'prop-types';
import { destroyToken } from 'actions/tokenCreators';

const SignOutLink = ({ history, dispatch }) => (
  <a
    href="/sign-in"
    className="sign-out-link"
    onClick={(e) => {
      e.preventDefault();
      dispatch(destroyToken());
      history.push('/sign-in');
    }}
  >
    Sign Out
  </a>
);

SignOutLink.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default SignOutLink;
